import { render, staticRenderFns } from "./member-order-give.component.vue?vue&type=template&id=d11a433c"
import script from "./member-order-give.component.vue?vue&type=script&lang=js"
export * from "./member-order-give.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports